import { Component } from 'vue-property-decorator';


import { Type } from "src/utils";

/**
 * 实物订单状态
 * @enum
 * @version 1.0.0
 */
enum OrderStatus
{
    /**
     * 已取消
     * @member
     */
    cancel = 0,

    /**
     * 待付款。
     * @member
     */
    toPay = 1,

    /**
     * 待发货。
     * @member
     */
    payed = 2,

    /**
     * 待收货。
     * @member
     */
    ship = 3,

    /**
     * 待评价。
     * @member
     */
    receipt = 4,

    /**
     * 已评价。
     * @member
     */
    evaluate = 5,

    /**
     * 退款中 
     * @member
     */
    applyRefund = 6,

    /**
     * 已退款 
     * @member
     */
    refunded = 7
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(OrderStatus,
{
    cancel:
    {
        alias: "已取消",
        description: ""
    },
    toPay:
    {
        alias: "待付款",
        description: ""
    },
    payed:
    {
        alias: "待发货",
        description: ""
    },
    ship:
    {
        alias: "待收货",
        description: ""
    },
    receipt:
    {
        alias: "待评价",
        description: ""
    },
    evaluate:
    {
        alias: "已完成",
        description: ""
    },
    applyRefund:
    {
        alias: "退款中",
        description: ""
    },
    refunded:
    {
        alias: "已退款",
        description: ""
    }
});

export default OrderStatus;
